import {styled, css} from '../../styled-components';
import {TableRowProps} from './TableRowBase';
import {TableCellStyle} from '../TableCell';

export const TableRowStyle = styled.tr<TableRowProps>`
    display: table-row;
    background-color: ${props => props.theme.color.primary.light};
    color: lightgray;
    height: ${props => props.theme.spacing.units(5)};

    > ${TableCellStyle} {
        &:first-child {
            padding-left: ${props => props.theme.spacing.units(5)};
        }
        &:last-child {
            padding-right: ${props => props.theme.spacing.units(5)};
        }
    }
`;
